<template>

    <div class="user">
      <!--添加任务-->
      <div class="common-seach-wrap">
        <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
          <el-form-item label="路线名称">
            <el-input placeholder="请输入路线名称" v-model="formInline.search">
          
            </el-input>
          </el-form-item>
          <el-form-item >
            <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
          </el-form-item>
  
        </el-form>
      </div>
 
  
      <div class="product-content">
        <el-form ref="form" :model="form" label-width="100px">
          <div class="table-wrap">
            <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
        
              <!-- 基础信息列 -->
  <el-table-column prop="route_sign_id" label="报名ID" width="100" align="center"></el-table-column>
  
  <el-table-column prop="route_batch_id" label="批次ID" width="100" align="center"></el-table-column>

  <!-- 车辆信息列（分组显示） -->
  <el-table-column label="车辆信息" align="center">
    <el-table-column prop="vehicle_brand" label="品牌" width="120"></el-table-column>
    <el-table-column prop="vehicle_model" label="型号" width="120"></el-table-column>
    <el-table-column prop="vehicle_plate" label="车牌" width="150">
      <template #default="{row}">
        <el-tag>{{ row.vehicle_plate }}</el-tag>
      </template>
    </el-table-column>
  </el-table-column>

  <!-- 推荐人信息列 -->
  <el-table-column label="推荐人" align="center">
    <el-table-column prop="referrer_name" label="姓名" width="120"></el-table-column>
    <el-table-column prop="referrer_phone" label="电话" width="150">
      <template #default="{row}">
        <a :href="`tel:${row.referrer_phone}`">{{ row.referrer_phone }}</a>
      </template>
    </el-table-column>
  </el-table-column>

  <!-- 系统信息列 -->
  <el-table-column prop="sort" label="排序" width="80" align="center"></el-table-column>
  
  <el-table-column prop="app_id" label="应用ID" width="100" align="center"></el-table-column>

  <!-- 时间列（格式化显示） -->
  <el-table-column prop="create_time" label="创建时间" width="180" align="center">
  </el-table-column>



            
            </el-table>
          </div>
        </el-form>
        <!--分页-->
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background
            :current-page="curPage"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="totalDataNumber"
          ></el-pagination>
        </div>
      </div>
      
  
      <el-dialog  style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible' 
      :close-on-click-modal="false" 
                 :close-on-press-escape="false" :append-to-body="true">
      </el-dialog>
    
    </div>
  </template>
  
  <script>
    import RouteApi from '@/api/route.js';

    export default {
      components: {

      },
      inject: ['reload'],
      data() {
        return {
          /*是否加载完成*/
          loading: true,
          /*列表数据*/
          tableData: [],
          /*一页多少条*/
          pageSize: 20,
          /*一共多少条数据*/
          totalDataNumber: 0,
          /*当前是第几页*/
          curPage: 1,
          /*搜索表单对象*/
          form: {},
          formInline: {
            search:""
          },
  
          open_add:false,
          open_edit:false,
          route_id:"",
          dialogVisible:false,
        };
      },
      created() {
  
        /*获取列表*/
        this.getTableList();
      },
      methods: {
        dialogFormVisible(){
          this.dialogVisible = false;
        },
        setting(e){//路线标题设置
          // this.categorya_id = e
          this.dialogVisible = true;
        },
         /*关闭添加*/
      closeAdd(e){
        this.open_add=false;
        this.getTableList();
      },
      closeEdit(e){
        this.open_edit=false;
        this.getTableList();
      },
      getData(){
        this.getTableList();
      },
        /*选择第几页*/
        handleCurrentChange(val) {
          this.curPage = val;
          this.getTableList();
        },
  
        /*每页多少条*/
        handleSizeChange(val) {
          this.curPage = 1;
          this.pageSize = val;
          this.getTableList();
        },
  
        /*获取列表*/
        getTableList() {
          let self = this;
          let Params = this.formInline;
          Params.page = self.curPage;
          Params.list_rows = self.pageSize;
          self.loading = true;
          RouteApi.signlist(Params, true)
            .then(data => {
              self.loading = false;
              self.tableData = data.data.list.data;
              self.totalDataNumber = data.data.list.total;
            })
            .catch(error => {
            });
        },
  
        /*搜索查询*/
        onSubmit() {
          this.curPage = 1;
          this.getTableList();
        },
  
        /*添加任务*/
        addClick() {
          this.open_add = true
        },
  
        /*编辑活动*/
        editClick(row) {
          this.route_id = row.route_id;
          this.open_edit = true
        },
  
        /*删除*/
        deleteClick(row) {
          let self = this;
          self
            .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
            .then(() => {
              RouteApi.del(
                {
                  route_id: row.route_id
                },
                true
              )
                .then(data => {
                  if (data.code == 1) {
                    self.$message({
                      message: '删除成功',
                      type: 'success'
                    });
                    this.getTableList();
                  } else {
                    self.$message.error('错了哦，这是一条错误消息');
                  }
                })
                .catch(error => {
                });
            })
            .catch(() => {
            });
        }
      }
    };
  </script>
  
  <style></style>
  


// WEBPACK FOOTER //
// src/views/plus/route/sign/index.vue